<template>
  <header class="header">
    <div class="container header__content">
      <div class="header__brand">
        <a href="https://www.fundacionapoyo.com">
          <img src="@/assets/logo-fundacion.svg" alt="Fundación Apoyo">
        </a>
      </div>
      <div class="header__message">
        <span class="header__eyebrow">Fundación Apoyo</span>
        <strong>Solicitud de crédito en línea</strong>
        <small>Un proceso seguro, sencillo y confidencial</small>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'HeaderComponent',
  props: { }
}
</script>
<style scoped>
  .header__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
  }

  .header__brand img {
    display: block;
  }

  .header__message {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.25;
  }

  .header__message strong {
    font-size: 20px;
  }

  .header__message small,
  .header__eyebrow {
    color: #dce9ff;
    font-size: 12px;
  }

  .header__eyebrow {
    text-transform: uppercase;
    letter-spacing: .12em;
    font-weight: 700;
  }

  @media (max-width: 640px) {
    .header__content {
      justify-content: center;
    }

    .header__message {
      display: none;
    }
  }
</style>
